

// / FIREBASE AUTH ACTIONS
export const LOGIN_WITH_PROVIDER_FIREBASE = 'LOGIN_WITH_PROVIDER_FIREBASE';
export const REGISTER_FIREBASE_USER = 'REGISTER_FIREBASE_USER';
export const LOGIN_FIREBASE_USER = 'LOGIN_FIREBASE_USER';
export const FETCH_FIREBASE_USER = 'FETCH_FIREBASE_USER';
export const UPDATE_FIREBASE_USER = 'UPDATE_FIREBASE_USER';
export const CHANGE_FIREBASE_USER_PASSWORD = 'CHANGE_FIREBASE_USER_PASSWORD';
export const FIREBASE_PASSWORD_RESET_EMAIL = 'FIREBASE_PASSWORD_RESET_EMAIL';
export const LOGOUT_FIREBASE_USER = 'LOGOUT_FIREBASE_USER';

// Driver's profile
export const GET_DRIVER_PROFILE = 'GET_DRIVER_PROFILE';
export const UPDATE_INPUT_DRIVER_PROFILE = 'UPDATE_INPUT_DRIVER_PROFILE';
export const UPDATE_INPUT_CV_DRIVER_PROFILE = 'UPDATE_INPUT_CV_DRIVER_PROFILE';
export const SUBMIT_DRIVER_PROFILE = 'SUBMIT_DRIVER_PROFILE';
export const LOAD_CITY_SELECT_OPTIONS = 'LOAD_CITY_SELECT_OPTIONS';

// Cars
export const GET_CARS = 'GET_CARS';
export const UPDATE_INPUT_CAR = 'UPDATE_INPUT_CAR';
export const SUBMIT_UPDATED_CAR = 'SUBMIT_UPDATED_CAR';
export const DELETE_CAR = 'DELETE_CAR';

// New car
export const UPDATE_INPUT_NEW_CAR = 'UPDATE_INPUT_NEW_CAR';
export const SUBMIT_NEW_CAR = 'SUBMIT_NEW_CAR';

// Fuel Records
export const GET_FUEL_RECORDS = "GET_FUEL_RECORDS";
export const DELETE_FUEL_RECORD = "DELETE_FUEL_RECORD";
export const GET_ALL_FUEL_RECORDS = "GET_ALL_FUEL_RECORDS";

// One Fuel Record
export const UPDATE_INPUT_FUEL_RECORD = 'UPDATE_INPUT_FUEL_RECORD';
export const UPDATE_INPUT_BILL_PHOTO_URL = 'UPDATE_INPUT_BILL_PHOTO_URL';
export const SUBMIT_FUEL_RECORD = 'SUBMIT_FUEL_RECORD';
export const CLEAR_ONE_FUEL_RECORD = 'CLEAR_ONE_FUEL_RECORD';
export const SET_RECORD_TO_ONE_FUEL_RECORD = 'SET_RECORD_TO_ONE_FUEL_RECORD';
export const UPDATE_FUEL_RECORD = 'UPDATE_FUEL_RECORD';

// All Users
export const GET_ALL_TRACKER_USERS_WITH_PROFILE = 'GET_ALL_TRACKER_USERS_WITH_PROFILE';
export const GET_ALL_USERS_WITH_PROFILE = 'GET_ALL_USERS_WITH_PROFILE';
export const ADD_NOTE_TO_USER = 'ADD_NOTE_TO_USER';
export const REMOVE_NOTE_FROM_USER = 'REMOVE_NOTE_FROM_USER';
export const SET_VERIFIED_TO_USER = 'SET_VERIFIED_TO_USER';
export const SET_IS_ACTIVE_TO_USER = 'SET_IS_ACTIVE_TO_USER';



// WEBPACK FOOTER //
// ./src/app/actions/types.js